import { 
  StoreDisplayGroupPlanogram, 
  StoreDisplayGroupDetailAlgorithm, 
  StoreDisplayGroupDetailManual
} from '../types/storeDisplayGroupPlanogram';
import { Item } from '../types/item';
import { itemList } from './itemData';

// 创建待下架商品的Mock数据映射
const createItemMockData = (itemCodes: string[]): Item[] => {
  const baseItems: { [key: string]: Omit<Item, 'id'> } = {
    'ITEM001': { code: 'ITEM001', name: '苹果 - 富士', ownerCode: 'OWNER001', category: '水果', status: 'ACTIVE' },
    'ITEM002': { code: 'ITEM002', name: '香蕉 - 进口', ownerCode: 'OWNER001', category: '水果', status: 'ACTIVE' },
    'ITEM003': { code: 'ITEM003', name: '橙子 - 脐橙', ownerCode: 'OWNER001', category: '水果', status: 'ACTIVE' },
    'ITEM004': { code: 'ITEM004', name: '牛奶 - 全脂', ownerCode: 'OWNER002', category: '乳制品', status: 'ACTIVE' },
    'ITEM005': { code: 'ITEM005', name: '酸奶 - 原味', ownerCode: 'OWNER002', category: '乳制品', status: 'ACTIVE' },
    'ITEM010': { code: 'ITEM010', name: '矿泉水 - 500ml', ownerCode: 'OWNER003', category: '饮料', status: 'INACTIVE' },
    'ITEM011': { code: 'ITEM011', name: '薯片 - 原味', ownerCode: 'OWNER003', category: '零食', status: 'INACTIVE' },
    'ITEM012': { code: 'ITEM012', name: '巧克力 - 黑巧', ownerCode: 'OWNER003', category: '零食', status: 'ACTIVE' },
    'ITEM020': { code: 'ITEM020', name: '充电器 - Type-C', ownerCode: 'OWNER004', category: '电子产品', status: 'ACTIVE' },
    'ITEM021': { code: 'ITEM021', name: '电池 - AA', ownerCode: 'OWNER004', category: '电子产品', status: 'ACTIVE' },
    'ITEM022': { code: 'ITEM022', name: '耳机 - 蓝牙', ownerCode: 'OWNER004', category: '电子产品', status: 'ACTIVE' },
    'ITEM023': { code: 'ITEM023', name: '洗发水 - 去屑', ownerCode: 'OWNER005', category: '个护用品', status: 'ACTIVE' },
    'ITEM024': { code: 'ITEM024', name: '牙膏 - 美白', ownerCode: 'OWNER005', category: '个护用品', status: 'ACTIVE' },
    'ITEM025': { code: 'ITEM025', name: '纸巾 - 面巾纸', ownerCode: 'OWNER005', category: '个护用品', status: 'ACTIVE' },
    'ITEM026': { code: 'ITEM026', name: '洗衣液 - 柔顺', ownerCode: 'OWNER005', category: '个护用品', status: 'ACTIVE' },
    'ITEM027': { code: 'ITEM027', name: '沐浴露 - 滋润', ownerCode: 'OWNER005', category: '个护用品', status: 'ACTIVE' },
    'ITEM030': { code: 'ITEM030', name: '咖啡 - 速溶', ownerCode: 'OWNER006', category: '饮料', status: 'ACTIVE' },
    'ITEM031': { code: 'ITEM031', name: '茶叶 - 绿茶', ownerCode: 'OWNER006', category: '饮料', status: 'ACTIVE' },
    'ITEM040': { code: 'ITEM040', name: '大米 - 优质', ownerCode: 'OWNER007', category: '粮食', status: 'ACTIVE' },
    'ITEM041': { code: 'ITEM041', name: '面粉 - 高筋', ownerCode: 'OWNER007', category: '粮食', status: 'ACTIVE' },
    'ITEM042': { code: 'ITEM042', name: '食用油 - 花生油', ownerCode: 'OWNER007', category: '调料', status: 'ACTIVE' },
    'ITEM043': { code: 'ITEM043', name: '酱油 - 生抽', ownerCode: 'OWNER007', category: '调料', status: 'ACTIVE' },
    'ITEM044': { code: 'ITEM044', name: '鸡蛋 - 散养', ownerCode: 'OWNER008', category: '蛋类', status: 'ACTIVE' },
    'ITEM045': { code: 'ITEM045', name: '鸭蛋 - 新鲜', ownerCode: 'OWNER008', category: '蛋类', status: 'ACTIVE' },
    'ITEM046': { code: 'ITEM046', name: '面包 - 全麦', ownerCode: 'OWNER008', category: '烘焙', status: 'ACTIVE' },
    'ITEM047': { code: 'ITEM047', name: '饼干 - 苏打', ownerCode: 'OWNER008', category: '烘焙', status: 'ACTIVE' },
    'ITEM048': { code: 'ITEM048', name: '蛋糕 - 奶油', ownerCode: 'OWNER008', category: '烘焙', status: 'ACTIVE' },
    'ITEM049': { code: 'ITEM049', name: '曲奇 - 巧克力', ownerCode: 'OWNER008', category: '烘焙', status: 'ACTIVE' }
  };

  // 简单的ID映射
  const getItemId = (code: string): number => {
    const match = code.match(/\d+/);
    return match ? parseInt(match[0]) : Math.floor(Math.random() * 1000) + 1000;
  };

  return itemCodes.map((code) => ({
    id: getItemId(code),
    ...baseItems[code] || {
      code,
      name: `未知商品 ${code}`,
      ownerCode: 'UNKNOWN',
      category: '其他',
      status: 'ACTIVE'
    }
  }));
};

// 解析JSON字符串为商品代码数组的辅助函数
const parseItemCodes = (itemCodesJson: string | undefined): string[] => {
  if (!itemCodesJson) return [];
  try {
    const parsed = JSON.parse(itemCodesJson);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

// Mock Planogram数据 - 包含完整的算法和人工详情
export const mockStoreDisplayGroupPlanogramData: StoreDisplayGroupPlanogram[] = [
  {
    id: 1,
    code: 'PLAN001',
    storeCode: 'SH001',
    storeName: 'Shanghai Pudong Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Store Group',
    displayGroupCode: 'DG001',
    displayGroupName: 'Electronics Display Group',
    source: 'benchmark',
    itemCount: 150,
    status: '生效中',
    description: '春季新品陈列图',
    imageUrl: 'https://example.com/planogram1.jpg',
    manualImageUrl: 'https://example.com/manual-planogram1.jpg',
    shelfCount: 12,
    shelfCodes: '["SH001", "SH002", "SH003"]',
    toBeDelistItemCount: 5,
    toBeDelistAlgItems: createItemMockData(parseItemCodes('["ITEM001", "ITEM002"]')),
    toBeDelistManulItems: createItemMockData(parseItemCodes('["ITEM003", "ITEM004", "ITEM005"]')),
    commercialApproverStatus: 'APPROVED',
    commercialApproverTime: '2024-01-15T10:30:00',
    commercialApproverAccount: 'commercial001',
    commercialApproverName: '张三',
    commercialApproverRemark: '商业审批通过，符合商业要求',
    planogramApproverStatus: 'APPROVED',
    planogramApproverTime: '2024-01-16T14:20:00',
    planogramApproverAccount: 'planogram001',
    planogramApproverName: '李四',
    planogramApproverRemark: '制图审批通过，布局合理',
    dataPathInOss: '/planograms/2024/plan001/',
    creatorAccount: 'creator001',
    creatorName: '王五',
    gmtCreate: '2024-01-10T09:00:00',
    modifierAccount: 'modifier001',
    modifierName: '赵六',
    gmtModified: '2024-01-16T16:00:00',
    deleted: 0
  },
  {
    id: 2,
    code: 'PLAN002',
    storeCode: 'SH001',
    storeName: 'Shanghai Pudong Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Store Group',
    displayGroupCode: 'DG002',
    displayGroupName: 'Food & Beverage Display Group',
    source: 'algorithm',
    itemCount: 200,
    status: '审核中',
    description: '智能算法生成陈列图',
    imageUrl: 'https://example.com/planogram2.jpg',
    manualImageUrl: undefined,
    shelfCount: 15,
    shelfCodes: '["SH004", "SH005", "SH006", "SH007"]',
    toBeDelistItemCount: 3,
    toBeDelistAlgItems: createItemMockData(parseItemCodes('["ITEM010", "ITEM011"]')),
    toBeDelistManulItems: createItemMockData(parseItemCodes('["ITEM012"]')),
    commercialApproverStatus: 'PENDING',
    commercialApproverTime: undefined,
    commercialApproverAccount: undefined,
    commercialApproverName: undefined,
    commercialApproverRemark: undefined,
    planogramApproverStatus: 'PENDING',
    planogramApproverTime: undefined,
    planogramApproverAccount: undefined,
    planogramApproverName: undefined,
    planogramApproverRemark: undefined,
    dataPathInOss: '/planograms/2024/plan002/',
    creatorAccount: 'creator002',
    creatorName: '孙七',
    gmtCreate: '2024-01-12T11:30:00',
    modifierAccount: 'modifier002',
    modifierName: '周八',
    gmtModified: '2024-01-18T10:15:00',
    deleted: 0
  },
  {
    id: 3,
    code: 'PLAN003',
    storeCode: 'SH002',
    storeName: 'Shanghai Xuhui Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Store Group',
    displayGroupCode: 'DG001',
    displayGroupName: 'Electronics Display Group',
    source: 'benchmark',
    itemCount: 120,
    status: '草稿',
    description: '夏季促销陈列图',
    imageUrl: undefined,
    manualImageUrl: 'https://example.com/manual-planogram3.jpg',
    shelfCount: 10,
    shelfCodes: '["SH008", "SH009"]',
    toBeDelistItemCount: 8,
    toBeDelistAlgItems: createItemMockData(parseItemCodes('["ITEM020", "ITEM021", "ITEM022"]')),
    toBeDelistManulItems: createItemMockData(parseItemCodes('["ITEM023", "ITEM024", "ITEM025", "ITEM026", "ITEM027"]')),
    commercialApproverStatus: undefined,
    commercialApproverTime: undefined,
    commercialApproverAccount: undefined,
    commercialApproverName: undefined,
    planogramApproverStatus: undefined,
    planogramApproverTime: undefined,
    planogramApproverAccount: undefined,
    planogramApproverName: undefined,
    dataPathInOss: '/planograms/2024/plan003/',
    creatorAccount: 'creator003',
    creatorName: '吴九',
    gmtCreate: '2024-01-20T15:45:00',
    modifierAccount: 'creator003',
    modifierName: '吴九',
    gmtModified: '2024-01-20T15:45:00',
    deleted: 0
  },
  {
    id: 4,
    code: 'PLAN004',
    storeCode: 'SH001',
    storeName: 'Shanghai Pudong Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Store Group',
    displayGroupCode: 'DG003',
    displayGroupName: 'Personal Care Display Group',
    source: 'benchmark',
    itemCount: 180,
    status: '审核拒绝',
    description: '节庆特色陈列图',
    imageUrl: 'https://example.com/planogram4.jpg',
    shelfCount: 14,
    shelfCodes: '["SH010", "SH011", "SH012"]',
    toBeDelistItemCount: 2,
    toBeDelistAlgItems: createItemMockData(parseItemCodes('["ITEM030"]')),
    toBeDelistManulItems: createItemMockData(parseItemCodes('["ITEM031"]')),
    commercialApproverStatus: 'REJECTED',
    commercialApproverTime: '2024-01-25T09:30:00',
    commercialApproverAccount: 'commercial002',
    commercialApproverName: '钱十',
    commercialApproverRemark: '商业审批不通过，需要重新调整商品结构',
    planogramApproverStatus: 'PENDING',
    planogramApproverTime: undefined,
    planogramApproverAccount: undefined,
    planogramApproverName: undefined,
    planogramApproverRemark: undefined,
    dataPathInOss: '/planograms/2024/plan004/',
    creatorAccount: 'creator004',
    creatorName: '陈十一',
    gmtCreate: '2024-01-22T13:20:00',
    modifierAccount: 'modifier003',
    modifierName: '林十二',
    gmtModified: '2024-01-25T11:00:00',
    deleted: 0
  },
  {
    id: 5,
    code: 'PLAN005',
    storeCode: 'SH003',
    storeName: 'Beijing Chaoyang Store',
    shopGroupCode: 'SG002',
    shopGroupName: 'Beijing Store Group',
    displayGroupCode: 'DG001',
    displayGroupName: 'Electronics Display Group',
    source: 'algorithm',
    itemCount: 225,
    status: '已归档',
    description: '秋季新品算法陈列图',
    imageUrl: 'https://example.com/planogram5.jpg',
    shelfCount: 18,
    shelfCodes: '["SH013", "SH014", "SH015", "SH016"]',
    toBeDelistItemCount: 10,
    toBeDelistAlgItems: createItemMockData(parseItemCodes('["ITEM040", "ITEM041", "ITEM042", "ITEM043"]')),
    toBeDelistManulItems: createItemMockData(parseItemCodes('["ITEM044", "ITEM045", "ITEM046", "ITEM047", "ITEM048", "ITEM049"]')),
    commercialApproverStatus: 'APPROVED',
    commercialApproverTime: '2024-01-18T16:45:00',
    commercialApproverAccount: 'commercial003',
    commercialApproverName: '黄十三',
    commercialApproverRemark: '商业审批通过，符合秋季促销要求',
    planogramApproverStatus: 'APPROVED',
    planogramApproverTime: '2024-01-19T10:20:00',
    planogramApproverAccount: 'planogram002',
    planogramApproverName: '何十四',
    planogramApproverRemark: '制图审批通过，算法布局优化良好',
    dataPathInOss: '/planograms/2024/plan005/',
    creatorAccount: 'creator005',
    creatorName: '高十五',
    gmtCreate: '2024-01-15T08:30:00',
    modifierAccount: 'modifier004',
    modifierName: '白十六',
    gmtModified: '2024-01-30T14:30:00',
    deleted: 0
  }
];

/**
 * 根据筛选条件和分页参数获取Planogram数据
 */
export const getMockPlanogramData = (
  filters: any = {},
  pagination: any = { page: 1, pageSize: 20 }
) => {
  let filteredData = [...mockStoreDisplayGroupPlanogramData];

  // 应用筛选条件
  if (filters.storeCode) {
    filteredData = filteredData.filter(item => item.storeCode === filters.storeCode);
  }

  if (filters.shopGroupCode) {
    filteredData = filteredData.filter(item => item.shopGroupCode === filters.shopGroupCode);
  }

  if (filters.displayGroupCode) {
    filteredData = filteredData.filter(item => item.displayGroupCode === filters.displayGroupCode);
  }

  if (filters.division) {
    // Since we don't have division field in planogram data, we'll simulate based on display group
    // This would normally be handled by the backend
    filteredData = filteredData.filter(item => {
      // Simulate division filtering based on display group code
      if (filters.division === 'DIV001') {
        return item.displayGroupCode === 'DG001'; // Electronics
      } else if (filters.division === 'DIV002') {
        return ['DG002', 'DG003'].includes(item.displayGroupCode); // Food & Personal Care
      }
      return true;
    });
  }

  if (filters.status) {
    filteredData = filteredData.filter(item => item.status === filters.status);
  }

  if (filters.source) {
    filteredData = filteredData.filter(item => item.source === filters.source);
  }

  if (filters.commercialApproverStatus) {
    filteredData = filteredData.filter(item => item.commercialApproverStatus === filters.commercialApproverStatus);
  }

  if (filters.planogramApproverStatus) {
    filteredData = filteredData.filter(item => item.planogramApproverStatus === filters.planogramApproverStatus);
  }

  if (filters.keyword) {
    const keyword = filters.keyword.toLowerCase();
    filteredData = filteredData.filter(item => 
      item.code.toLowerCase().includes(keyword) ||
      (item.description && item.description.toLowerCase().includes(keyword))
    );
  }

  // 应用排序
  if (pagination.sortBy) {
    const { sortBy, sortOrder = 'desc' } = pagination;
    filteredData.sort((a, b) => {
      const aValue = a[sortBy as keyof StoreDisplayGroupPlanogram];
      const bValue = b[sortBy as keyof StoreDisplayGroupPlanogram];
      
      if (aValue === undefined || aValue === null) return 1;
      if (bValue === undefined || bValue === null) return -1;
      
      let comparison = 0;
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        comparison = aValue.localeCompare(bValue);
      } else if (typeof aValue === 'number' && typeof bValue === 'number') {
        comparison = aValue - bValue;
      } else {
        comparison = String(aValue).localeCompare(String(bValue));
      }
      
      return sortOrder === 'asc' ? comparison : -comparison;
    });
  }

  // 应用分页
  const { page = 1, pageSize = 20 } = pagination;
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  return {
    success: true,
    data: {
      tableData: paginatedData,
      paging: {
        currentPage: page,
        totalCount: filteredData.length,
        pageSize: pageSize
      }
    },
    errorMessage: null,
    traceId: `mock-${Date.now()}`,
    flag: 'success' as const
  };
};

/**
 * 根据code获取单个Planogram数据
 */
export const getMockPlanogramByCode = (code: string) => {
  const planogram = mockStoreDisplayGroupPlanogramData.find(item => item.code === code);
  
  if (planogram) {
    return {
      success: true,
      data: planogram,
      errorMessage: null,
      traceId: `mock-${Date.now()}`,
      flag: 'success' as const
    };
  } else {
    return {
      success: false,
      data: null,
      errorMessage: `Planogram with code ${code} not found`,
      traceId: `mock-${Date.now()}`,
      flag: 'fail' as const
    };
  }
};

export default mockStoreDisplayGroupPlanogramData;

// 导出用于测试的工具函数
export { createItemMockData, parseItemCodes };

// Mock 算法结果详情数据
export const mockAlgorithmDetailsData: StoreDisplayGroupDetailAlgorithm[] = [
  {
    id: 1,
    planogramCode: 'PLAN001',
    shelfCode: 'SH001',
    layer: 'L1',
    shelfIndex: 1,
    ownerCode: 'OWNER001',
    itemCode: 'ITEM001',
    seqOnShelfLayer: 1,
    facingCount: 3,
    verticalCount: 2,
    depthCount: 4,
    pdqCount: 2,
    creatorAccount: 'algorithm_system',
    creatorName: '算法系统',
    gmtCreate: '2024-01-10T09:00:00',
    modifierAccount: 'algorithm_system',
    modifierName: '算法系统',
    gmtModified: '2024-01-10T09:00:00',
    deleted: 0
  },
  {
    id: 2,
    planogramCode: 'PLAN001',
    shelfCode: 'SH001',
    layer: 'L1',
    shelfIndex: 2,
    ownerCode: 'OWNER001',
    itemCode: 'ITEM002',
    seqOnShelfLayer: 2,
    facingCount: 2,
    verticalCount: 3,
    depthCount: 3,
    pdqCount: 1,
    creatorAccount: 'algorithm_system',
    creatorName: '算法系统',
    gmtCreate: '2024-01-10T09:00:00',
    modifierAccount: 'algorithm_system',
    modifierName: '算法系统',
    gmtModified: '2024-01-10T09:00:00',
    deleted: 0
  },
  {
    id: 3,
    planogramCode: 'PLAN001',
    shelfCode: 'SH001',
    layer: 'L2',
    shelfIndex: 1,
    ownerCode: 'OWNER002',
    itemCode: 'ITEM003',
    seqOnShelfLayer: 1,
    facingCount: 4,
    verticalCount: 2,
    depthCount: 5,
    pdqCount: 3,
    creatorAccount: 'algorithm_system',
    creatorName: '算法系统',
    gmtCreate: '2024-01-10T09:00:00',
    modifierAccount: 'algorithm_system',
    modifierName: '算法系统',
    gmtModified: '2024-01-10T09:00:00',
    deleted: 0
  },
  {
    id: 4,
    planogramCode: 'PLAN001',
    shelfCode: 'SH002',
    layer: 'L1',
    shelfIndex: 1,
    ownerCode: 'OWNER001',
    itemCode: 'ITEM004',
    seqOnShelfLayer: 1,
    facingCount: 5,
    verticalCount: 1,
    depthCount: 6,
    pdqCount: 0,
    creatorAccount: 'algorithm_system',
    creatorName: '算法系统',
    gmtCreate: '2024-01-10T09:00:00',
    modifierAccount: 'algorithm_system',
    modifierName: '算法系统',
    gmtModified: '2024-01-10T09:00:00',
    deleted: 0
  },
  {
    id: 5,
    planogramCode: 'PLAN001',
    shelfCode: 'SH002',
    layer: 'L2',
    shelfIndex: 2,
    ownerCode: 'OWNER003',
    itemCode: 'ITEM005',
    seqOnShelfLayer: 2,
    facingCount: 3,
    verticalCount: 4,
    depthCount: 2,
    pdqCount: 4,
    creatorAccount: 'algorithm_system',
    creatorName: '算法系统',
    gmtCreate: '2024-01-10T09:00:00',
    modifierAccount: 'algorithm_system',
    modifierName: '算法系统',
    gmtModified: '2024-01-10T09:00:00',
    deleted: 0
  }
];

// Mock 人工结果详情数据
export const mockManualDetailsData: StoreDisplayGroupDetailManual[] = [
  {
    id: 101,
    planogramCode: 'PLAN001',
    shelfCode: 'SH001',
    layer: 'L1',
    shelfIndex: 1,
    ownerCode: 'OWNER001',
    itemCode: 'ITEM001',
    seqOnShelfLayer: 1,
    facingCount: 4,  // 人工调整后的数量
    verticalCount: 2,
    depthCount: 4,
    pdqCount: 2,
    creatorAccount: 'manual_user001',
    creatorName: '手动调整员',
    gmtCreate: '2024-01-11T10:30:00',
    modifierAccount: 'manual_user001',
    modifierName: '手动调整员',
    gmtModified: '2024-01-11T10:30:00',
    deleted: 0
  },
  {
    id: 102,
    planogramCode: 'PLAN001',
    shelfCode: 'SH001',
    layer: 'L1',
    shelfIndex: 2,
    ownerCode: 'OWNER001',
    itemCode: 'ITEM002',
    seqOnShelfLayer: 2,
    facingCount: 3,  // 人工调整后的数量
    verticalCount: 3,
    depthCount: 3,
    pdqCount: 1,
    creatorAccount: 'manual_user001',
    creatorName: '手动调整员',
    gmtCreate: '2024-01-11T10:35:00',
    modifierAccount: 'manual_user002',
    modifierName: '高级调整员',
    gmtModified: '2024-01-12T14:20:00',
    deleted: 0
  },
  {
    id: 103,
    planogramCode: 'PLAN001',
    shelfCode: 'SH001',
    layer: 'L2',
    shelfIndex: 1,
    ownerCode: 'OWNER002',
    itemCode: 'ITEM003',
    seqOnShelfLayer: 1,
    facingCount: 3,  // 人工调整后的数量
    verticalCount: 2,
    depthCount: 5,
    pdqCount: 2,  // 人工调整后的数量
    creatorAccount: 'manual_user002',
    creatorName: '高级调整员',
    gmtCreate: '2024-01-11T11:00:00',
    modifierAccount: 'manual_user002',
    modifierName: '高级调整员',
    gmtModified: '2024-01-11T11:00:00',
    deleted: 0
  },
  {
    id: 104,
    planogramCode: 'PLAN001',
    shelfCode: 'SH002',
    layer: 'L1',
    shelfIndex: 1,
    ownerCode: 'OWNER001',
    itemCode: 'ITEM006',  // 人工新增的商品
    seqOnShelfLayer: 1,
    facingCount: 2,
    verticalCount: 1,
    depthCount: 4,
    pdqCount: 1,
    creatorAccount: 'manual_user002',
    creatorName: '高级调整员',
    gmtCreate: '2024-01-12T15:45:00',
    modifierAccount: 'manual_user002',
    modifierName: '高级调整员',
    gmtModified: '2024-01-12T15:45:00',
    deleted: 0
  }
];

/**
 * 获取算法结果详情Mock数据
 */
export const getMockAlgorithmDetails = (
  planogramCode: string,
  filters: any = {}
) => {
  let filteredData = mockAlgorithmDetailsData.filter(
    item => item.planogramCode === planogramCode
  );

  // 应用筛选条件
  if (filters.shelfCode) {
    filteredData = filteredData.filter(item => item.shelfCode === filters.shelfCode);
  }

  if (filters.layer) {
    filteredData = filteredData.filter(item => item.layer === filters.layer);
  }

  if (filters.itemCode) {
    filteredData = filteredData.filter(item => 
      item.itemCode.toLowerCase().includes(filters.itemCode.toLowerCase())
    );
  }

  if (filters.ownerCode) {
    filteredData = filteredData.filter(item => item.ownerCode === filters.ownerCode);
  }

  return {
    success: true,
    data: filteredData,
    errorMessage: null,
    traceId: `mock-algorithm-${Date.now()}`,
    flag: 'success' as const
  };
};

/**
 * 获取人工结果详情Mock数据
 */
export const getMockManualDetails = (
  planogramCode: string,
  filters: any = {}
) => {
  let filteredData = mockManualDetailsData.filter(
    item => item.planogramCode === planogramCode
  );

  // 应用筛选条件
  if (filters.shelfCode) {
    filteredData = filteredData.filter(item => item.shelfCode === filters.shelfCode);
  }

  if (filters.layer) {
    filteredData = filteredData.filter(item => item.layer === filters.layer);
  }

  if (filters.itemCode) {
    filteredData = filteredData.filter(item => 
      item.itemCode.toLowerCase().includes(filters.itemCode.toLowerCase())
    );
  }

  if (filters.ownerCode) {
    filteredData = filteredData.filter(item => item.ownerCode === filters.ownerCode);
  }

  return {
    success: true,
    data: filteredData,
    errorMessage: null,
    traceId: `mock-manual-${Date.now()}`,
    flag: 'success' as const
  };
};

/**
 * 获取Planogram完整详情Mock数据
 */
export const getMockPlanogramDetail = (planogramCode: string) => {
  const planogram = mockStoreDisplayGroupPlanogramData.find(
    item => item.code === planogramCode
  );

  if (!planogram) {
    return {
      success: false,
      data: null,
      errorMessage: `Planogram with code ${planogramCode} not found`,
      traceId: `mock-detail-${Date.now()}`,
      flag: 'fail' as const
    };
  }

  const algorithmDetails = mockAlgorithmDetailsData.filter(
    item => item.planogramCode === planogramCode
  );

  const manualDetails = mockManualDetailsData.filter(
    item => item.planogramCode === planogramCode
  );

  // 将详情数据合并到planogram对象中
  const detailWithCombinedData: StoreDisplayGroupPlanogram = {
    ...planogram,
    algorithmDetails,
    manualDetails
  };

  return {
    success: true,
    data: detailWithCombinedData,
    errorMessage: null,
    traceId: `mock-detail-${Date.now()}`,
    flag: 'success' as const
  };
};